<template>
  <div class="main-wrapper">
    <div style="height: 10px"></div>
    <el-row :gutter="20">
      <el-col :span="20">
        <el-form :inline="true" :model="formInline">
          <el-form-item label="类型">
            <el-select v-model="formInline.status" placeholder="工单状态">
              <el-option
                v-for="status in getAllTicketStatus()"
                :key="status"
                :label="getTicketStatus(status)"
                :value="status"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input v-model="formInline.userName" placeholder="用户名"></el-input>
          </el-form-item>
          <el-form-item label="工单编号">
            <el-input v-model="formInline.ticketNo" placeholder="工单编号"></el-input>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input v-model="formInline.keyword" placeholder="关键字"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="btnSearchClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-table :data="tickets" style="width: 100%">
      <el-table-column label="工单编号" width="100">
        <template #default="scope">
          <span :class="getClassName(scope.row)">
            {{ scope.row.ticketNo }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="用户名称" width="150">
        <template #default="scope">
          <span :class="getClassName(scope.row)">
            {{ scope.row.userName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="工单类型" width="150">
        <template #default="scope">
          <span :class="getClassName(scope.row)">
            {{ getTicketCategory(scope.row) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="问题内容">
        <template #default="scope">
          <el-link
            type="primary"
            :class="getClassName(scope.row)"
            :underline="false"
            @click.prevent="btnViewClick(scope.row)"
          >
            <span v-if="isUnread(scope.row)">【未读】</span>
            {{ scope.row.content }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" width="145">
        <template #default="scope">
          <span :class="getClassName(scope.row)">
            {{ scope.row.createdDate }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="140">
        <template #default="scope">
          <el-tag :class="getClassName(scope.row)" :type="getTicketStatusType(scope.row)">
            {{ getTicketStatus(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="工单类型" align="center" width="140">
        <template #default="scope">
          <el-tag :class="getClassName(scope.row)" :type="getTicketPriorityType(scope.row)">
            {{ getTicketPriority(scope.row.priority) }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>

    <div style="text-align: center; margin-top: 10px">
      <el-pagination
        v-on:current-change="handleCurrentChange"
        :current-page="formInline.currentPage"
        :page-size="formInline.limit"
        layout="total, prev, pager, next, jumper"
        :total="count"
      ></el-pagination>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ITicket } from '@/types/models';
import api, {
  IGetRequest,
} from '@/api/admin/tickets';
import { PER_PAGE } from '@/const';
import utils from '@/utils';
import { TicketCategory, TicketPriority, TicketStatus } from '@/types/enums';

interface IForm extends IGetRequest {
  currentPage: number;
}

interface IState {
  count: number;
  tickets: ITicket[];
  formInline: IForm;
}

export default defineComponent({
  name: 'Tickets',
  data() {
    return {
      count: 0,
      tickets: [],
      isMessages: false,
      messagesCount: 0,
      messages: [],
      isAdd: false,
      formInline: {
        userName: '',
        status: TicketStatus.Dealing,
        ticketNo: '',
        keyword: '',
        currentPage: 1,
        offset: 0,
        limit: PER_PAGE,
      },
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.formInline, (res) => {
        this.count = res.count;
        this.tickets = res.tickets;
      });
    },

    getAllTicketStatus() {
      return Object.values(TicketStatus);
    },

    getTicketStatusType(ticket: ITicket) {
      if (ticket.status === TicketStatus.Closed) {
        return 'success';
      }
      if (ticket.status === TicketStatus.Dealing) {
        return 'danger';
      }
      return 'primary';
    },

    getTicketPriorityType(ticket: ITicket) {
      if (ticket.priority === TicketPriority.High) {
        return 'danger';
      }
      return 'primary';
    },

    getTicketStatus(status: TicketStatus) {
      if (status === TicketStatus.Waiting) return '待用户回复';
      if (status === TicketStatus.Dealing) return '待处理';
      if (status === TicketStatus.Closed) return '工单已关闭';
      return '全部';
    },

    getTicketPriority(status: TicketPriority) {
      return utils.getTicketPriority(status);
    },

    getTicketCategory(category: TicketCategory) {
      return utils.getTicketCategory(category);
    },

    btnSearchClick() {
      this.apiGet();
    },

    handleCurrentChange(val: number) {
      this.formInline.currentPage = val;
      this.formInline.offset = this.formInline.limit * (val - 1);

      this.btnSearchClick();
    },

    btnViewClick(ticket: ITicket) {
      ticket.isRead = true;
      utils.pageOpen(`/admin/tickets/${ticket.ticketNo}`);
    },

    isUnread(ticket: ITicket) {
      return ticket.status === TicketStatus.Dealing && !ticket.isRead;
    },

    getClassName(ticket: ITicket) {
      if (ticket.status === TicketStatus.Dealing && !ticket.isRead) {
        return 'unread';
      }
      return '';
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
